// Authentication 
export const LOGIN_USER = "login_user"
export const LOGIN_USER_SUCCESS = "login_user_success"
export const LOGIN_USER_FAILURE = "login_user_failure"

export const LOGOUT_USER = "logout_user"
export const LOGOUT_USER_SUCCESS = "logout_user_success"

export const CHANGE_PASSWORD = "change_password"
export const CHANGE_PASSWORD_SUCCESS = "change_password_success"
export const CHANGE_PASSWORD_FAILURE = "change_password_failure"
export const CHANGE_PASSWORD_RESET = "change_password_reset"

export const AUTH_CM_GUID = "auth_cm_guid"
export const AUTH_CM_GUID_SUCCESS = "auth_cm_guid_success"
export const AUTH_CM_GUID_FAILURE = "auth_cm_guid_failure"

// Skills
export const ADD_SKILL_SET = "add_skill_set"
export const ADD_SKILL_SET_SUCCESS = "add_skill_set_success"
export const FETCH_ALL_SKILL_SET = "fetch_all_skill_set"
export const FETCH_ALL_SKILL_SET_SUCCESS = "fetch_all_skill_set_success"
export const EMPTY_SKILL_SET = "empty_skill_set"
export const RESTORE_SKILL_SET_INITIAL = "restore_skill_set_initial"
export const ACTIVATE_SKILL_SET = "activate_skill_set"
export const ACTIVATE_SKILL_SET_SUCCESS = "activate_skill_set_success"
export const DEACTIVATE_SKILL_SET = "deactivate_skill_set"
export const DEACTIVATE_SKILL_SET_SUCCESS = "deactivate_skill_set_success"
export const FETCH_SKILL_SET_BY_ID = "fetch_skill_set_by_id"
export const FETCH_SKILL_SET_BY_ID_SUCCESS = "fetch_skill_set_by_id_success"
export const EMPTY_SKILL_SET_BY_ID = "empty_skill_set_by_id"
export const CREATE_SUBSKILL = "create_subskill"
export const CREATE_SUBSKILL_SUCCESS = "create_subskill_success"
export const FETCH_SUBSKILL_BY_SKILL_ID = "fetch_subskill_by_skill_id"
export const FETCH_SUBSKILL_BY_SKILL_ID_SUCCESS = "fetch_subskill_by_skill_id_success"
export const EMPTY_SUBSKILL_BY_SKILL_ID = "empty_subskill_by_skill_id"
export const EMPTY_SUBSKILL_BY_SKILL_ID_SUCCESS = "empty_subskill_by_skill_id_success"

export const FETCH_ALL_TOTAL_SKILLS_DATA = "fetch_all_total_skills_data"
export const FETCH_ALL_TOTAL_SKILLS_DATA_SUCCESS = "fetch_all_total_skills_data_success"
export const EMPTY_TOTAL_SKILL_SET = "empty_skill_set"
export const UPDATE_SKILL_SET = "update_skill_set"
export const UPDATE_SKILL_SET_SUCCESS = "update_skill_set_success"

export const UPDATE_SUB_SKILL = "update_sub_skill"
export const UPDATE_SUB_SKILL_SUCCESS = "update_sub_skill_success"
export const UPDATE_SUB_SKILL_FAILURE = "update_sub_skill_failure" 
export const RESET_UPDATE_SUB_SKILL = "reset_update_sub_skill"

export const FETCH_SKILL_SELECT = "fetch_skill_select"
export const FETCH_SKILL_SELECT_SUCCESS = "fetch_skill_select_success"
export const EMPTY_SKILL_SELECT = "empty_skill_select"

export const FETCH_STATES = "fetch_states"
export const FETCH_STATES_SUCCESS = "fetch_states_success"
export const EMPTY_STATES = "empty_states"

export const FETCH_SKILLCENTRES_BY_STATE = "fetch_skillcentres_state"
export const FETCH_SKILLCENTRES_BY_STATE_SUCCESS = "fetch_skillcentres_state_success"
export const EMPTY_SKILLCENTRES_BY_STATE = "empty_skill_centres_by_state"


export const UPDATE_MULTIPLE_SUB_SKILLS = "update_multiple_sub_skills"
export const UPDATE_MULTIPLE_SUB_SKILLS_SUCCESS = "update_multiple_sub_skills_success"


export const IMPORT_SKILL_SET = "import_skill_set"
export const IMPORT_SKILL_SET_SUCCESS = "import_skill_set_success"

export const IMPORT_SUB_SKILL = "import_sub_skill"
export const IMPORT_SUB_SKILL_SUCCESS = "import_sub_skill_success"


// Trainers
export const ADD_TRAINER = "add_trainer"
export const ADD_TRAINER_SUCCESS = "add_trainer_success" 
export const FETCH_ALL_TRAINERS = "fetch_all_trainers"
export const FETCH_ALL_TRAINERS_SUCCESS = "fetch_all_trainers_success"
export const EMPTY_ALL_TRAINERS = "empty_all_trainers"
export const RESTORE_TRAINER_INITIAL = "restore_trainer_initial"
export const ACTIVATE_TRAINER = "activate_trainer"
export const ACTIVATE_TRAINER_SUCCESS = "activate_trainer_success"
export const DEACTIVATE_TRAINER = "deactivate_trainer"
export const DEACTIVATE_TRAINER_SUCCESS = "deactivate_trainer_success"
export const FETCH_TRAINER_BY_ID = "fetch_trainer_by_id"
export const FETCH_TRAINER_BY_ID_SUCCESS = "fetch_trainer_by_id_success"
export const EMPTY_TRAINER_BY_ID = "empty_trainer_by_id"

export const FETCH_TRAINER_BY_EMAIL = "fetch_trainer_by_email"
export const FETCH_TRAINER_BY_EMAIL_SUCCESS = "fetch_trainer_by_email_success"
export const FETCH_TRAINER_BY_EMAIL_FAILURE = "fetch_trainer_by_email_failure"
export const EMPTY_TRAINER_BY_EMAIL = "empty_trainer_by_email"

export const UPDATE_TRAINING_CENTER = "update_training_center"
export const UPDATE_TRAINING_CENTER_SUCCESS = "update_training_center_success"
export const UPDATE_TRAINING_CENTER_FAILURE = "update_training_center_failure"

export const FETCH_ALL_TOTAL_TRAINERS_DETAILS = "fetch_all_total_trainers_details"
export const FETCH_ALL_TOTAL_TRAINERS_DETAILS_SUCCESS = "fetch_all_total_trainers_details_success"
export const EMPTY_TOTAL_TRAINERS = "empty_trainers"
export const UPDATE_TRAINER = "update_trainer"
export const UPDATE_TRAINER_SUCCESS = "update_trainer_success"
export const EXPORT_TRAINERS = "export_trainers"
export const EXPORT_TRAINERS_SUCCESS = "export_trainers_success"
export const PRINT_TRAINERS = "print_trainers"
export const PRINT_TRAINERS_SUCCESS = "print_trainers_success"

export const FETCH_TRAINER_SELECT = "fetch_trainer_select"
export const FETCH_TRAINER_SELECT_SUCCESS = "fetch_trainer_select_success"
export const EMPTY_TRAINER_SELECT = "empty_trainer_select"

export const DOWNLOAD_TRAINER_BULK_TEMPLATE = "download_trainer_bulk_template"
export const DOWNLOAD_TRAINER_BULK_TEMPLATE_SUCCESS = "download_trainer_bulk_template_success"

export const ADD_BULK_TRAINER = "add_bulk_trainer"
export const ADD_BULK_TRAINER_SUCCESS = "add_bulk_trainer_success"

// trainer approval or rejection
export const POST_APPROVAL_COMMENT = 'POST_APPROVAL_COMMENT';
export const POST_APPROVAL_COMMENT_SUCCESS = 'POST_APPROVAL_COMMENT_SUCCESS';

export const EXPORT_VIRTUALLY_APPROVED_TRAINERS = "export_virtually_approved_trainers"
export const EXPORT_VIRTUALLY_APPROVED_TRAINERS_SUCCESS = "export_virtually_approved_trainers_success"
export const EXPORT_VIRTUALLY_APPROVED_TRAINERS_FAILURE = "export_virtually_approved_trainers_failure"
export const EXPORT_VIRTUALLY_APPROVED_TRAINERS_RESET = "export_virtually_approved_trainers_reset"

export const EXPORT_PHYSICALLY_APPROVED_TRAINERS = "export_physically_approved_trainers"
export const EXPORT_PHYSICALLY_APPROVED_TRAINERS_SUCCESS = "export_physically_approved_trainers_success"
export const EXPORT_PHYSICALLY_APPROVED_TRAINERS_FAILURE = "export_physically_approved_trainers_failure"
export const EXPORT_PHYSICALLY_APPROVED_TRAINERS_RESET = "export_physically_approved_trainers_reset"


// Skills Acquisition Centres
export const FETCH_ALL_SKILL_CENTRES = "fetch_all_skill_centres"
export const FETCH_ALL_SKILL_CENTRES_SUCCESS = "fetch_all_skill_centres_success"

export const CREATE_SKILL_CENTRE = "create_skill_centre"
export const CREATE_SKILL_CENTRE_SUCCESS = "create_skill_centre_success"

export const ACTIVATE_SKILL_CENTRE = "activate_skill_centre"
export const ACTIVATE_SKILL_CENTRE_SUCCESS = "activate_skill_centre_success"

export const DEACTIVATE_SKILL_CENTRE = "deactivate_skill_centre"
export const DEACTIVATE_SKILL_CENTRE_SUCCESS = "deactivate_skill_centre_success"

export const EDIT_SKILL_CENTRE = "EDIT_skill_centre"
export const EDIT_SKILL_CENTRE_SUCCESS = "EDIT_skill_centre_success"

export const FETCH_SKILL_CENTER_SELECT = "fetch_skill_center_select"
export const FETCH_SKILL_CENTER_SELECT_SUCCESS = "fetch_skill_center_select_success"
export const EMPTY_SKILL_CENTER_SELECT = "empty_skill_center_select"


export const FETCH_TOTAL_SKILL_CENTER_DETAILS = "FETCH_TOTAL_SKILL_CENTER_DETAILS"
export const FETCH_TOTAL_SKILL_CENTER_DETAILS_SUCCESS = "FETCH_TOTAL_SKILL_CENTER_DETAILS_success"

export const HANDLE_API_ERROR = "handle_api_error"

export const MAKE_REQUEST = "make_request"

export const EXPORT_SKILLS = "export_skills"
export const EXPORT_SKILLS_SUCCESS = "export_skills_success"

export const RESTORE_SKILL_ACQUISITION_CENTRE_INITIAL = "restore_skill_acquisition_centre_initial"
export const PRINT_SKILLS = "print_skills"
export const PRINT_SKILLS_SUCCESS = "print_skills_success"

export const DOWNLOAD_SKILL_CENTER_BULK_TEMPLATE = "download_skill_center_bulk_template"
export const DOWNLOAD_SKILL_CENTER_BULK_TEMPLATE_SUCCESS = "download_skill_center_bulk_template_success"

export const ADD_BULK_SKILL_CENTER = "add_bulk_skill_center"
export const ADD_BULK_SKILL_CENTER_SUCCESS = "add_bulk_skill_center_success"


// Partners 
export const FETCH_ALL_PARTNERS = "fetch_all_partners"
export const FETCH_ALL_PARTNERS_SUCCESS = "fetch_all_partners_success"
export const FETCH_ALL_PARTNERS_FAILURE = "fetch_all_partners_failure" 

export const FETCH_PARTNER_BY_ID = "fetch_partner_by_id"
export const FETCH_PARTNER_BY_ID_SUCCESS = "fetch_partner_by_id_success"
export const FETCH_PARTNER_BY_ID_FAILURE = "fetch_partner_by_id_failure"
export const RESET_FETCH_PARTNER_BY_ID = "reset_fetch_partner_by_id"

export const FETCH_PARTNER_DASHBOARD_DETAILS = "fetch_partner_dashboard_details"
export const FETCH_PARTNER_DASHBOARD_DETAILS_SUCCESS = "fetch_partner_dashboard_details_success"

export const CREATE_PARTNER = "create_partner"
export const CREATE_PARTNER_SUCCESS = "create_partner_success"
export const CREATE_PARTNER_FAILURE = 'create_partner_failure'

export const ACTIVATE_PARTNER = "activate_partner"
export const ACTIVATE_PARTNER_SUCCESS = "activate_partner_success"

export const DEACTIVATE_PARTNER = "deactivate_partner"
export const DEACTIVATE_PARTNER_SUCCESS = "deactivate_partner_success"

export const EDIT_PARTNER = "edit_partner"
export const EDIT_PARTNER_SUCCESS = "edit_partner_success"
export const EDIT_PARTNER_FAILURE = "edit_partner_failure"

export const RESET_ACTION_DIALOG = 'reset_action_dialog'

export const EXPORT_PARTNER = "export_partner"
export const EXPORT_PARTNER_SUCCESS = "export_partner_success"

export const PRINT_PARTNERS = "print_partners"
export const PRINT_PARTNERS_SUCCESS = "print_partners_success"

export const RESTORE_PARTNERS_INITIAL = "restore_partners_initial"

export const DOWNLOAD_PARTNER_BULK_TEMPLATE = "download_partner_bulk_template"
export const DOWNLOAD_PARTNER_BULK_TEMPLATE_SUCCESS = "download_partner_bulk_template_success"

export const ADD_BULK_PARTNER = "add_bulk_partner"
export const ADD_BULK_PARTNER_SUCCESS = "add_bulk_partner_success"

export const MAKE_REQUEST_PARTNERS = "make_request_partners";
export const FETCH_DIALOG_DATA = "fetch_dialog_data";
export const SEARCH_TABLE = "search_table"

export const PRINT_SKILL_ACQUISITION = "print_skill_acquisition"
export const PRINT_SKILL_ACQUISITION_SUCCESS = "print_skill_acquisition_success"

export const EXPORT_SKILL_ACQUISITION = "export_skill_acquisition"
export const EXPORT_SKILL_ACQUISITION_SUCCESS = "export_skill_acquisition_success"



// Loan Beneficiaries
export const FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS = "fetch_total_loan_beneficiaries_details";
export const FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS_SUCCESS = "fetch_total_loan_beneficiaries_details_success";

export const FETCH_ALL_LOAN_BENEFICIARIES_LS = "fetch_all_loan_beneficiaries_ls";
export const FETCH_ALL_LOAN_BENEFICIARIES_LS_SUCCESS = "fetch_all_loan_beneficiaries_ls_success";

export const FETCH_DATA_FOR_PRINTING = "fetch_data_for_printing";
export const FETCH_DATA_FOR_PRINTING_SUCCESS = "fetch_data_for_printing_success";

export const ADD_PAYMENT_TO_LOAN_BENEFICIARY = "add_payment_to_loan_beneficiary";
export const ADD_PAYMENT_TO_LOAN_BENEFICIARY_SUCCESS = "add_payment_to_loan_beneficiary_success";

export const FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID = "fetch_payment_by_loan_beneficiary_id";
export const FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID_SUCCESS = "fetch_payment_by_loan_beneficiary_id_success";

export const MAKE_REQUEST_LOAN_STATUS = "make_request_loan_status";
export const RESTORE_LOAN_STATUS_INITIAL = "restore_loan_status_initial";

export const FETCH_PAYMENT_BY_PAYMENT_ID = "fetch_payment_by_payment_id";
export const FETCH_PAYMENT_BY_PAYMENT_ID_SUCCESS = "fetch_payment_by_payment_id_success";

export const EXPORT_LOAN_BENEFICIARIES = "export_loan_beneficiaries";
export const EXPORT_LOAN_BENEFICIARIES_SUCCESS = "export_loan_beneficiaries_success";

export const FETCH_ALL_LOANS_FOR_FILTER = "fetch_all_loans_for_filter";
export const FETCH_ALL_LOANS_FOR_FILTER_SUCCESS = "fetch_all_loans_for_filter_success";

export const FETCH_LOAN_BENEFICIARY_BY_ID = "fetch_loan_beneficiary_by_id";
export const FETCH_LOAN_BENEFICIARY_BY_ID_SUCCESS = "fetch_loan_beneficiary_by_id_success";



// business management
export const FETCH_CORPS_MEMBER = "fetch_corps_member"
export const FETCH_CORPS_MEMBER_SUCCESS = "fetch_corps_member_success"
export const FETCH_CORPS_MEMBER_FAILURE = "fetch_corps_member_failure"


export const EMPTY_FETCH_CORPS_MEMBER = "empty_fetch_corps_member"

export const CREATE_BUSINESS_MANAGEMENT = "create_business_management"
export const CREATE_BUSINESS_MANAGEMENT_SUCCESS = "create_business_management_success"
export const CREATE_BUSINESS_MANAGEMENT_FAILURE = "create_business_management_failure"

export const FETCH_ALL_BUSINESS_MANAGEMENT = "fetch_all_business_management"
export const FETCH_ALL_BUSINESS_MANAGEMENT_SUCCESS = "fetch_all_business_management_success"

export const RESTORE_BUSINESS_INITIAL = "restore_business_initial"

export const EXPORT_BUSINESS_MANAGEMENT = "export_business_management"
export const EXPORT_BUSINESS_MANAGEMENT_SUCCESS = "export_business_management_success"

export const UPDATE_BUSINESS_MANAGEMENT = "update_business_management"
export const UPDATE_BUSINESS_MANAGEMENT_SUCCESS = "update_business_management_success"
export const UPDATE_BUSINESS_MANAGEMENT_FAILURE = "update_business_management_failure"

export const FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION = "fetch_business_management_without_pagination"
export const FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS = "fetch_business_management_without_pagination_success"

export const EMPTY_FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION = "empty_fetch_business_management_without_pagination"

export const FETCH_TOTAL_BUSINESS_MANAGEMENT = "fetch_total_business_management"
export const FETCH_TOTAL_BUSINESS_MANAGEMENT_SUCCESS = "fetch_total_business_management_success"

export const RESTORE_CORPS_MEMBER_DETAILS = "restore_corps_member_details"

export const FETCH_BUSINESS_MANAGEMENT_BY_ID =  "fetch_business_management_by_id"
export const FETCH_BUSINESS_MANAGEMENT_BY_ID_SUCCESS = "fetch_business_management_by_id_success"



// Loan Setup
export const ADD_LOAN = "add_loan"
export const ADD_LOAN_SUCCESS = "add_loan_success"
export const ADD_LOAN_FAILURE = "add_loan_failure" 

export const FETCH_ALL_LOANS = "fetch_all_loans"
export const FETCH_ALL_LOANS_SUCCESS = "fetch_all_loans_success"
export const FETCH_ALL_LOANS_FAILURE = "fetch_all_loans_failure"

export const EMPTY_ALL_LOANS = "empty_all_loans"
export const RESTORE_LOAN_INITIAL = "restore_loan_initial"

export const ACTIVATE_LOAN = "activate_loan"
export const ACTIVATE_LOAN_SUCCESS = "activate_loan_success"
export const DEACTIVATE_LOAN = "deactivate_loan"
export const DEACTIVATE_LOAN_SUCCESS = "deactivate_loan_success"
export const FETCH_LOAN_BY_ID = "fetch_loan_by_id"
export const FETCH_LOAN_BY_ID_SUCCESS = "fetch_loan_by_id_success"
export const EMPTY_LOAN_BY_ID = "empty_loan_by_id"
export const FETCH_ALL_TOTAL_LOAN_DETAILS = "fetch_all_total_loan_details"
export const FETCH_ALL_TOTAL_LOAN_DETAILS_SUCCESS = "fetch_all_total_loan_details_success"
export const EMPTY_TOTAL_LOANS = "empty_loans"
export const UPDATE_LOAN = "update_loan"
export const UPDATE_LOAN_SUCCESS = "update_loan_success"
export const EXPORT_LOANS = "export_loans"
export const EXPORT_LOANS_SUCCESS = "export_loans_success"
export const FETCH_LOAN_SELECT = "fetch_loan_select"
export const FETCH_LOAN_SELECT_SUCCESS = "fetch_loan_select_success"
export const EMPTY_LOAN_SELECT = "empty_loan_select"
export const FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS = "fetch_all_total_loan_beneficiary_details"
export const FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS_SUCCESS = "fetch_all_total_loan_beneficiary_details_success"
export const EMPTY_ALL_TOTAL_LOAN_BENEFICIARY = "empty_all_total_loan_beneficiary"
export const ADD_CM_TO_LOAN = "add_cm_to_loan"
export const ADD_CM_TO_LOAN_SUCCESS = "add_cm_to_loan_success" 
export const FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN = "fetch_all_loan_beneficiaries_to_loan"
export const FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN_SUCCESS = "fetch_all_loan_beneficiaries_to_loan_success"
export const EMPTY_ALL_LOAN_BENEFICIARIES_TO_LOAN = "empty_all_loan-beneficiaries_to_loan"
export const RESTORE_LOAN_BENEFICIARIES_TO_LOAN_INITIAL = "restore_loan_beneficiaries_to_loan_initial"
export const EXPORT_LOAN_BENEFICIARIES_BY_LOAN = "export_loan_beneficiaries_by_loan"
export const  EXPORT_LOAN_BENEFICIARIES_BY_LOAN_SUCCESS = "export_loan_beneficiaries_by_loan_success"

export const DOWNLOAD_LOAN_BULK_TEMPLATE = "download_loan_bulk_template"
export const DOWNLOAD_LOAN_BULK_TEMPLATE_SUCCESS = "download_loan_bulk_template_success"

export const ADD_BULK_LOAN = "add_bulk_loan"
export const ADD_BULK_LOAN_SUCCESS = "add_bulk_loan_success"

export const DOWNLOAD_LOAN_BENEFICIARY_BULK_TEMPLATE = "download_loan_beneficiary_bulk_template"
export const DOWNLOAD_LOAN_BENEFICIARY_BULK_TEMPLATE_SUCCESS = "download_loan_beneficiary_bulk_template_success"

export const ADD_BULK_LOAN_BENEFICIARY = "add_bulk_loan_beneficiary"
export const ADD_BULK_LOAN_BENEFICIARY_SUCCESS = "add_bulk_loan_beneficiary_success"



//Activity
export const FETCH_ALL_USER_ACTIVITY = "fetch_all_user_activity"
export const FETCH_ALL_USER_ACTIVITY_SUCCESS = "fetch_all_user_activity_success"



// Training Centre Registration
export const SAVE_FORM_DATA_PART_ONE = "save_form_data_part_one"
export const SAVE_FORM_DATA_PART_ONE_SUCCESS = "save_form_data_part_one_success"

export const SAVE_FORM_DATA_PART_TWO = "save_form_data_part_two"
export const SAVE_FORM_DATA_PART_TWO_SUCCESS = "save_form_data_part_two_success"

export const SAVE_FORM_DATA_PART_THREE = "save_form_data_part_three"
export const SAVE_FORM_DATA_PART_THREE_SUCCESS = "save_form_data_part_three_success"
export const SEND_TRAINING_REG_DATA_TO_API = "send_training_reg_data_to_api"

export const TREG_FETCH_ALL_STATES = "treg_fetch_all_states"
export const TREG_FETCH_ALL_STATES_SUCCESS = "treg_fetch_all_states_success"

export const REGISTER_TRAINING_CENTRE = "register_training_centre"
export const REGISTER_TRAINING_CENTRE_SUCCESS = "register_training_centre_success"
export const REGISTER_TRAINING_CENTRE_FAILURE = "register_training_centre_failure"
export const RESET_TRAINING_CENTRE_REG = "reset_training_centre_reg"

export const FETCH_ALL_ACTIVE_SKILLS_TREG = "fetch_all_active_skills_treg"
export const FETCH_ALL_ACTIVE_SKILLS_TREG_SUCCESS = "fetch_all_active_skills_treg_success"

export const NEXT_FORM_STEP = "next_form_step"
export const PREVIOUS_FORM_STEP = "previous_form_step"
export const RESET_FORM_STEP = "reset_form_step"

export const UPLOAD_OWNER_PASSPORT = "upload_owner_passport"
export const SET_PART_3_PAGE_DIRECTION = "set_part_3_page_direction"

export const OPEN_PART_ONE_POPUP = "open_part_one_popup"
export const CLOSE_PART_ONE_POPUP = "close_part_one_popup"

export const OPEN_TC_POPUP = "open_tc_popup"
export const CLOSE_TC_POPUP = "close_tc_popup"


// Virtual Approval
export const VIRTUALLY_APPROVE_TRAINER = 'virtually_approve_trainer'
export const VIRTUALLY_APPROVE_TRAINER_SUCCESS = 'virtually_approve_trainer_success'
export const VIRTUALLY_APPROVE_TRAINER_FAILURE = 'virtually_approve_trainer_failure'
export const RESET_VIRTUAL_APPROVAL_STATES = 'reset_virtual_approval_states'; 

export const SAVE_CURRENT_TRAINER_ID = "save_current_trainer_id";
export const RESET_CURRENT_TRAINER_ID = "reset_current_trainer_id";

export const FETCH_TRAINING_CENTER_FILE_BY_ID = 'fetch_training_center_file_by_id'
export const FETCH_TRAINING_CENTER_FILE_BY_ID_SUCCESS = 'fetch_training_center_file_by_id_success'
export const FETCH_TRAINING_CENTER_FILE_BY_ID_FAILURE = 'fetch_training_center_file_by_id_failure'
export const FETCH_TRAINING_CENTER_FILE_BY_ID_RESET = 'fetch_training_center_file_by_id_reset'

// Physical Approval
export const PA_FETCH_ALL_TRAINERS = 'pa_fetch_all_trainers' 
export const PA_FETCH_ALL_TRAINERS_SUCCESS = 'pa_fetch_all_trainers_success' 
export const PA_FETCH_ALL_TRAINERS_FAILURE = 'pa_fetch_all_trainers_failure' 

export const PA_NEXT_FORM_STEP = 'pa_next_form_step'
export const PA_PREVIOUS_FORM_STEP = 'pa_previous_form_step'
export const PA_RESET_FORM_STEP = 'pa_reset_form_step'

export const UPDATE_CURRENT_TRAINING_CENTER_ID = "update_current_training_center_id"
export const RESET_CURRENT_TRAINING_CENTER_ID = "reset_current_training_center_id"

export const PA_FETCH_TRAINER_BY_ID = 'pa_fetch_trainer_by_id' 
export const PA_FETCH_TRAINER_BY_ID_SUCCESS = 'pa_fetch_trainer_by_id_success' 
export const PA_FETCH_TRAINER_BY_ID_FAILURE = 'pa_fetch_trainer_by_id_failure' 
export const PA_RESET_TRAINER_BY_ID = 'pa_reset_trainer_by_id'

export const PHYSICALLY_APPROVE_TRAINER = 'physically_approve_trainer'
export const PHYSICALLY_APPROVE_TRAINER_SUCCESS = 'physically_approve_trainer_success'
export const PHYSICALLY_APPROVE_TRAINER_FAILURE = 'physically_approve_trainer_failure'
export const PHYSICALLY_APPROVE_TRAINER_RESET = 'physically_approve_trainer_reset'


// Training Center Report Page
export const FETCH_TRAINING_CENTER_REPORT = "fetch_training_center_report"
export const FETCH_TRAINING_CENTER_REPORT_SUCCESS = "fetch_training_center_report_success"
export const FETCH_TRAINING_CENTER_REPORT_FAILURE = "fetch_training_center_report_failure"

export const PRINT_TRAINING_CENTER_REPORT = "print_training_center_report"
export const PRINT_TRAINING_CENTER_REPORT_SUCCESS = "print_training_center_report_success"
export const PRINT_TRAINING_CENTER_REPORT_FAILURE = "print_training_center_report_failure"
export const RESET_PRINT_TRAINING_CENTER_REPORT = "reset_print_training_center_report"

export const EXPORT_TRAINING_CENTER_REPORT = "export_training_center_report"
export const EXPORT_TRAINING_CENTER_REPORT_SUCCESS = "export_training_center_report_success"
export const EXPORT_TRAINING_CENTER_REPORT_FAILURE = "export_training_center_report_failure"
export const RESET_EXPORT_TRAINING_CENTER_REPORT = "reset_export_training_center_report"

// Manage Post Camp Activities
export const EXPORT_PCA_REPORT = 'export_pca_report'
export const EXPORT_PCA_REPORT_SUCCESS = 'export_pca_report_success'
export const EXPORT_PCA_REPORT_FAILURE = 'export_pca_report_failure'
export const RESET_EXPORT_PCA_REPORT = 'reset_export_pca_report'

export const PCA_FIND_CM = 'pca_find_cm'
export const PCA_FIND_CM_SUCCESS = 'pca_find_cm_success'
export const PCA_FIND_CM_FAILURE = 'pca_find_cm_failure'
export const RESET_PCA_FIND_CM = 'reset_pca_find_cm' 

export const PCA_FETCH_ALL_ACTIVE_SKILLS = 'pca_fetch_all_active_skills'
export const PCA_FETCH_ALL_ACTIVE_SKILLS_SUCCESS = 'pca_fetch_all_active_skills_success'
export const PCA_FETCH_ALL_ACTIVE_SKILLS_FAILURE = 'pca_fetch_all_active_skills_failure'

export const CREATE_PCA_RECORD = 'create_pca_record'
export const CREATE_PCA_RECORD_SUCCESS = 'create_pca_record_success'
export const CREATE_PCA_RECORD_FAILURE = 'create_pca_record_failure'
export const RESET_CREATE_PCA_RECORD = 'reset_create_pca_record'

export const GET_ALL_REGISTERED_CM_PCA = 'get_all_registered_cm_pca'
export const GET_ALL_REGISTERED_CM_SUCCESS_PCA = 'get_all_registered_cm_success_pca'
export const GET_ALL_REGISTERED_CM_FAILURE_PCA = 'get_all_registered_cm_failure_pca'

export const GET_CM_PCA_BY_ID = 'get_cm_pca_by_id'
export const GET_CM_PCA_BY_ID_SUCCESS = 'get_cm_pca_by_id_success'
export const GET_CM_PCA_BY_ID_FAILURE = 'get_cm_pca_by_id_failure'
export const GET_CM_PCA_BY_ID_RESET = 'get_cm_pca_by_id_reset'

export const EDIT_PCA_DATA = 'edit_pca_data'
export const EDIT_PCA_DATA_SUCCESS = 'edit_pca_data_success'
export const EDIT_PCA_DATA_FAILURE = 'edit_pca_data_failure'
export const EDIT_PCA_DATA_RESET = 'edit_pca_data_reset' 


// Manage In Camp Activities
export const GET_ALL_REGISTERED_CM_ICA = 'get_all_registered_cm_ica'
export const GET_ALL_REGISTERED_CM_SUCCESS_ICA = 'get_all_registered_cm_success_ica'
export const GET_ALL_REGISTERED_CM_FAILURE_ICA = 'get_all_registered_cm_failure_ica'

export const GET_CM_ICA_BY_ID ='get_cm_ica_by_id'
export const GET_CM_ICA_BY_ID_SUCCESS = 'get_cm_ica_by_id_success'
export const GET_CM_ICA_BY_ID_FAILURE = 'get_cm_ica_by_id_failure'
export const GET_CM_ICA_BY_ID_RESET = 'get_cm_ica_by_id_reset'

export const EXPORT_CM_TRAINING ='export_cm_training'
export const EXPORT_CM_TRAINING_SUCCESS = 'export_cm_training_success'
export const EXPORT_CM_TRAINING_FAILURE = 'export_cm_training_failure'
export const EXPORT_CM_TRAINING_RESET = 'export_cm_training_reset'

export const GET_ALL_ICA_NO_PAGINATION = "get_all_ica_no_pagination"
export const GET_ALL_ICA_NO_PAGINATION_SUCCESS = "get_all_ica_no_pagination_success"
export const GET_ALL_ICA_NO_PAGINATION_FAILURE = "get_all_ica_no_pagination_failure"
export const GET_ALL_ICA_NO_PAGINATION_FAILURE_RESET = "get_all_ica_no_pagination_failure_reset"

// Success Stories
export const CREATE_SUCCESS_STORY = "create_success_story"
export const CREATE_SUCCESS_STORY_SUCCESS = "create_success_story_success"
export const CREATE_SUCCESS_STORY_FAILURE = "create_success_story_failure"

export const FETCH_ALL_SUCCESS_STORY  = "fetch_all_success_story"
export const FETCH_ALL_SUCCESS_STORY_SUCCESS = "fetch_all_success_story_success"
export const FETCH_ALL_SUCCESS_STORY_FAILURE = "fetch_all_success_story_failure"

export const RESTORE_STORY_INITIAL = "restore_story_initial"

export const UPDATE_SUCCESS_STORY = "update_success_story"
export const UPDATE_SUCCESS_STORY_SUCCESS = "update_success_story_success"
export const UPDATE_SUCCESS_STORY_FAILURE = "update_success_story_failure"

export const FETCH_SUCCESS_STORY_WITHOUT_PAGINATION = "fetch_success_story_without_pagination"
export const FETCH_SUCCESS_STORY_WITHOUT_PAGINATION_SUCCESS = "fetch_success_story_without_pagination_success"
export const FETCH_SUCCESS_STORY_WITHOUT_PAGINATION_FAILURE = "fetch_success_story_without_pagination_failure"
export const EMPTY_FETCH_SUCCESS_STORY_WITHOUT_PAGINATION = "empty_fetch_success_story_without_pagination"

export const FETCH_TOTAL_SUCCESS_STORY = "fetch_total_success_story"
export const FETCH_TOTAL_SUCCESS_STORY_SUCCESS = "fetch_total_success_story_success"
export const FETCH_TOTAL_SUCCESS_STORY_FAILURE = "fetch_total_success_story_failure"

export const FETCH_SUCCESS_STORY_BY_ID =  "fetch_success_story_by_id"
export const FETCH_SUCCESS_STORY_BY_ID_SUCCESS = "fetch_success_story_by_id_success"
export const FETCH_SUCCESS_STORY_BY_ID_FAILURE = "fetch_success_story_by_id_failure"

export const APPROVE_SUCCESS_STORY = "approve_success_story"
export const APPROVE_SUCCESS_STORY_SUCCESS = "approve_success_story_success"
export const APPROVE_SUCCESS_STORY_FAILURE = "approve_success_story_failure"


export const REGISTER_LGI_USER = "register_lgi_user"
export const REGISTER_LGI_USER_SUCCESS = "register_lgi_user_success"
export const REGISTER_LGI_USER_FAILURE = "register_lgi_user_failure"
export const RESTORE_LGI_USER = "restore_lgi_user"


export const FETCH_ALL_LGI_USERS = "fetch_all_lgi_users"
export const FETCH_ALL_LGI_USERS_SUCCESS = "fetch_all_lgi_users_success"
export const FETCH_ALL_LGI_USERS_FAILURE = "fetch_all_lgi_users_failure"


export const RELOCATE_LGI = "relocate_lgi"
export const RELOCATE_LGI_SUCCESS = "relocate_lgi_success"
export const RELOCATE_LGI_FAILURE = "relocate_lgi_failure"


// CM In-camp Module
export const CREATE_IN_CAMP_TRAINING = "create_in_camp_training"
export const CREATE_IN_CAMP_TRAINING_SUCCESS = "create_in_camp_training_success"
export const CREATE_IN_CAMP_TRAINING_FAILURE = "create_in_camp_training_failure"
export const CREATE_IN_CAMP_TRAINING_RESET = "create_in_camp_training_reset"

export const UPDATE_IN_CAMP_TRAINING = "update_in_camp_training"
export const UPDATE_IN_CAMP_TRAINING_SUCCESS = "update_in_camp_training_success"
export const UPDATE_IN_CAMP_TRAINING_FAILURE = "update_in_camp_training_failure"
export const UPDATE_IN_CAMP_TRAINING_RESET = "update_in_camp_training_reset"



// Activate and deactivate LGI
export const ACTIVATE_LGI = "activate_lgi"
export const ACTIVATE_LGI_SUCCESS = "activate_lgi_success"
export const ACTIVATE_LGI_FAILURE = "activate_lgi_failure"

export const DEACTIVATE_LGI = "deactivate_lgi"
export const DEACTIVATE_LGI_SUCCESS = "deactivate_lgi_success"
export const DEACTIVATE_LGI_FAILURE = "deactivate_lgi_failure"


// Activate and deactivate LGI
export const RESET_PASSWORD = "reset_password"
export const RESET_PASSWORD_SUCCESS = "reset_password_success"
export const RESET_PASSWORD_FAILURE = "reset_password_failure"